// @flow

import React from 'react';
import PropTypes from 'prop-types';

import {Hidden, makeStyles, Typography} from '@material-ui/core';

import orderRequestImg from '../../../../../../assets/img/product-page/order-request.png';
import orderRequestMobileImg from '../../../../../../assets/img/product-page/order-request-mobile.png';
import {colors} from '../../../../../../assets/styles/colors';
import CustomModal from '../../../../../../elements/CustomModal/CustomModal';

import type {Theme} from '@material-ui/core';
type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 360,
    maxWidth: '100%',
    padding: theme.spacing(4, 1, 2, 1),
    overflowX: 'hidden',
    [theme.breakpoints.up('md')]: {
      width: 600,
    },
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: '#313135',
  },
  text: {
    color: colors.grey800,
    fontSize: 16,
    fontWeight: 400,
  },
  imageWrap: {
    marginTop: theme.spacing(2),
    width: '100%',
    '& img': {
      maxWidth: '100%',
    },
  },
}));

export default function OrderRequestModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.modal}
    >
      <div className={classes.root}>
        <Typography className={classes.title} align="center" gutterBottom>
          Pedir y pagar después
        </Typography>
        <Typography align="center" className={classes.text} gutterBottom>
          Cuando el comprador hace click al botón se abrirá un formulario para
          que deje su información
        </Typography>

        <div className={classes.imageWrap}>
          <Hidden mdUp>
            <img src={orderRequestMobileImg} alt="add to cart" />
          </Hidden>
          <Hidden smDown>
            <img src={orderRequestImg} alt="add to cart" />
          </Hidden>
        </div>
      </div>
    </CustomModal>
  );
}

OrderRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
